import { Logger } from '@alilc/lowcode-utils';

export default new Logger({ level: 'warn', bizName: 'renderer' });